import { AxiosResponse } from 'axios';
import cleanDeep from 'clean-deep';

import { api } from 'tools/api-service';

import { PutProfileRequest } from './types/put-profile.type';

export const putProfile = async (
    payload: Partial<PutProfileRequest>
): Promise<AxiosResponse<void>> => {
    const cleanPayload = cleanDeep(payload);

    const response = await api.put(`/account/profile`, cleanPayload);

    return response;
};
